module.exports = __webpack_public_path__ + "static/img/mulan_tiktok.dda6a659.png";